module.exports = __webpack_public_path__ + "img/Lightning_Sticks.a1b5bcfd.jpg";